export function toPx(value) {
    if (typeof value === 'number') {
        return `${value}px`;
    }
    return value;
}
//# sourceMappingURL=to-px.js.map